import type { FeedbackIconProps } from './FeedbackIconTypes';
import type { BasicIconName } from './IconMappings';
import { IconMapping } from './IconMappings';

interface FeedbackBasicIconProps extends FeedbackIconProps {
  icon: BasicIconName;
}

export const FeedbackIcon = ({ icon, ...props }: FeedbackBasicIconProps): JSX.Element => {
  const Icon = IconMapping[icon];
  return <Icon {...props} />;
};
